(() => {
  function updateTileParents() {
    const tiles = document.querySelectorAll('.merchandising-carousel .tile, .lastviewedproducts-content .tile');
    if (!tiles.length) return;

    tiles.forEach((tile) => {
      if (tile.classList.contains('nLoaded')) return;
      tile.classList.add('nLoaded');
      const actionWrapper = document.createElement('div');
      const compare = tile.querySelector('.product-compare-action');
      const quicklist = tile.querySelector('.addtoquicklist-wrapper');
      if (compare && quicklist) {
        actionWrapper.innerHTML = /* html */ `
        <div class="action-wrapper">
          ${compare.outerHTML}
          ${quicklist.outerHTML}
        </div>
        `;
        tile.querySelector('.footer').appendChild(actionWrapper);
      }

      /**
       * call for availability button replace add to cart
       */
      (() => {
        const updateButton = () => {
          const button = tile.querySelector('.buttons.group button');
          const input = tile.querySelector('.buttons.group input');
          const outOfStock = tile.querySelector('.live-stock-content.out-stock .live-outstock');
          if (button && outOfStock) {
            button.innerHTML = 'Call for Availability';
            button.classList.add('call-for-availability');
            outOfStock.innerHTML = 'Out of Stock';
            if (input) {
              input.remove();
            }
          }
        };

        updateButton();
      })();
    });
  }

  document.addEventListener('live-inventory-done', () => {
    setTimeout(() => {
      updateTileParents();
    }, 1000);
  }, false);
})();
